import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { Suspense } from "react";
import { z } from "zod";
import { secretsQueryOptions } from "@/app/secrets/api/get-secrets";
import { SecretsListSkeleton } from "@/app/secrets/components/secrets-list-skeleton";
import { SecretList } from "@/app/secrets/list/list";
import { nameFilterSchema } from "@/components/custom/filters/name-filter";

const secretTypeSchema = z.enum(["list", "new"]);

export const secretsSearchSchema = z.object({
  type: fallback(secretTypeSchema, "list").default("list"),
  newKey: fallback(z.string().optional(), "").default(""),
  ...nameFilterSchema.shape,
});

const defaultValues = {
  type: "list" as const,
  newKey: "",
  name: "",
};

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/auth/secrets/"
)({
  validateSearch: zodValidator(secretsSearchSchema),
  search: {
    middlewares: [stripSearchParams(defaultValues)],
  },
  beforeLoad: ({ context: { queryClient }, params }) => {
    queryClient.prefetchQuery(
      secretsQueryOptions({ binding: "project", scope: params })
    );
  },
  component: () => (
    <Suspense fallback={<SecretsListSkeleton />}>
      <SecretList />
    </Suspense>
  ),
});
